import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_ENDPOINT, USER_API_ENDPOINT } from './../config';
import { Role } from './../models/role.model';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  currentUserRole = {
    roleName: '',
    permissions: []
  };
  roleName = '';
  constructor(
    private http: HttpClient,
  ) { }

  getRoles(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/role/all').pipe(map(res => res));
  }

  getCompanyPermissions(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/company/permissions').pipe(map(res => res))
  }

  getCompanyNotifications(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/role/companyNotifications').pipe(map(res => res))
  }

  getRole(id: string): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/role/' + id).pipe(map(res => res));
  }

  getCurrentUserRoles(id: string): Observable<any> {
    let val = this.http.get(USER_API_ENDPOINT + '/role/' + id).pipe(map((res: any) => {
      this.currentUserRole.permissions = res.permissions;
      this.currentUserRole.roleName = res.roleName;
      this.roleName = res.roleName;
    }));

    return val;
  }

  visibleForCurrentUser(roles: string[]) {
    const result = roles.indexOf(this.roleName) !== -1;
    return result;
  }

  userHavePermission(permission: string) {
    var permitted = false;
    if (this.currentUserRole && this.currentUserRole.permissions){
      this.currentUserRole.permissions.forEach(allowedPermission => {
        for (const [key, value] of Object.entries(allowedPermission)){
          if (value == permission){
            permitted = true;
          }
        }
      });
    }
    return permitted;
  }

  // upsertRole(role: any): Observable<any> {
  //   return this.http.post(API_ENDPOINT + '/role/upsertRole', role).pipe(map(res => res));
  // }
  createRole(role: Role): Observable<any> {
    return this.http.post(USER_API_ENDPOINT + '/role', role).pipe(
      map(res => res)
    )
  }
  updateRole(role: Role): Observable<any> {
    return this.http.put(USER_API_ENDPOINT + '/role/' + role.id, role).pipe(
      map(res => res)
    )
  }
}
